<!--  Publisher (3) has disbable to delete user -->
<template>
  <div>
    <div style="display:none;justify-content:space-between;align-item:center;">
      <el-form :inline="true"
               @submit.native.prevent="searchUser">
        <el-form-item style="margin:0 0 0 5px">
          <el-input v-model="searchText"
                    placeholder="Search">
            <el-button slot="append"
                       icon="el-icon-search"
                       @click="searchUser"></el-button>
          </el-input>
        </el-form-item>
        <el-button v-if="isSearchMode"
                   type="primary"
                   @click="clearSearch"
                   plain>Clear</el-button>
      </el-form>

    </div>
    <hr>
	<!--
    <div style="display:flex; justify-content:flex-end; align-items:center;">
      <div class="user-info">Activated {{totalUsers - inactiveUsers}}</div>
      <div class="user-info">Inactive {{inactiveUsers}}</div>
      <div class="user-info">Total {{totalUsers}}</div>
      <div>
        <el-pagination v-if="!isSearchMode"
                       :background="true"
                       layout="prev, pager, next"
                       :current-page.sync="currentPage"
                       :page-size="10"
                       :total="totalUsers"
                       @current-change="handlePageChange()">
        </el-pagination>
      </div>
    </div>
	-->
	Not Closed
	<hr />
    <el-table :data="topicList"
              v-loading="loading"
              empty-text="No Data"
              style="width: 100%;">
      <el-table-column prop="topic.user_book_name"
                       label="BOOK COVER NAME"></el-table-column>
      <el-table-column prop="topic.topic"
                       label="Topic"></el-table-column>
	  <el-table-column prop="topic.create_date"
                  label="Date"></el-table-column>
      <el-table-column fixed="right"
                       label="OPERATIONS"
                       width="120">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click.native.prevent="viewTopic(topicList[scope.$index])">
            View</el-button>
        </template>
      </el-table-column>
    </el-table>
<!--
    <el-pagination v-if="!isSearchMode"
                   :background="true"
                   layout="total, prev, pager, next"
                   :current-page.sync="currentPage"
                   :page-size="10"
                   :total="totalUsers"
                   :page-count="totalUsers"
                   @current-change="handlePageChange()">
    </el-pagination>
	-->
	<el-button type="text"
                     size="small"
                     @click.native.prevent="showClosedBoard()">
            Show Closed</el-button>
			<hr>
    <el-table :data="closedList" id="closedTopicTable"
              v-loading="loading"
              empty-text="No Data"
              style="width: 100%;display:none">
      <el-table-column prop="topic.user_book_name"
                       label="BOOK COVER NAME"></el-table-column>
      <el-table-column prop="topic.topic"
                       label="Topic"></el-table-column>
	  <el-table-column prop="topic.create_date"
                  label="Date"></el-table-column>
      <el-table-column fixed="right"
                       label="OPERATIONS"
                       width="120">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click.native.prevent="viewTopic(closedList[scope.$index])">
            View</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import AuthHelper from '../../utils/auth.js';
export default {
  created() {
    // Get user pages will emit change of the pagination
    // So it needs to record the currentPage
    //this.currentPage = Number.isInteger(+this.$route.params.page)
    //  ? +this.$route.params.page
    //  : 1;
    //this.countAllUsers();
    //this.getInactiveUsers();
//    this.getBoards(this.currentPage);
    this.getBoards();
  },
  data() {
    return {
      isSearchMode: false,
      topicList: [],
      closedList: [],
      totalUsers: 0,
      currentPage: 0,
      loading: false,
      searchText: '',
      inactiveUsers: 0,
      userRole: AuthHelper.getRole(),
    };
  },
  watch: {
    $route(to, from) {
      if (Number.isInteger(+to.params.page)) this.getUsers(to.params.page);
    },
  },
  methods: {
    // getUsers(numOfPage) {
    //   this.loading = true;
    //   this.axios({
    //     method: 'get',
    //     url: `/users?page=${numOfPage}`,
    //   })
    //     .then(res => {
    //       if (res.data.success) {
    //         this.userDatas = res.data.results;
    //         this.loading = false;
    //       }
    //     })
    //     .catch(err => {});
	// },
	showClosedBoard(){
      this.loading = true;
      this.axios({
        method: 'get',
        url: '/boards/1',
      })
        .then(res => {
          if (res.data.success) {
			this.closedList = res.data.topics;
			this.loading = false;
			closedTopicTable.style.display = 'block';
          }
        })
        .catch(err => {});

	},
    getBoards() {
      this.loading = true;
      this.axios({
        method: 'get',
        url: `/boards/0`,
      })
        .then(res => {
          if (res.data.success) {
			this.topicList = res.data.topics;
            this.loading = false;
          }
        })
        .catch(err => {});
    },
    handlePageChange() {
      this.$router.push('/admin/list/' + this.currentPage);
      localStorage.page = this.currentPage;
    },
    viewTopic(row) {
		localStorage.userName = row.topic.user_book_name;
		this.$router.push(`/admin/${row.topic.user_id}/posts/${row.topic.id}`);
//      localStorage.userName = user.book_name;
//      this.$router.push(`/admin/${user.id}/profile`);
    },
    handleDelete(userID) {
      this.$confirm('Are you sure want to delete this user?', 'info', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.axios({
            method: 'delete',
            url: `/user/${userID}`,
          })
            .then(res => {
              this.userDatas = this.userDatas.filter(
                user => user.id !== userID
              );
              this.$message({
                type: 'success',
                message: 'User delete!',
              });
            })
            .catch(err => {
              this.$message({
                type: 'error',
              });
            });
        })
        .catch(() => {});
    },
    searchUser() {
      this.loading = true;
      this.axios({
        method: 'get',
        url: '/users/search',
        params: {
          text: this.searchText,
        },
      })
        .then(res => {
          this.isSearchMode = true;
          this.userDatas = res.data;
          this.loading = false;
        })
        .catch(err => {});
    },
    clearSearch() {
      this.isSearchMode = false;
      this.searchText = '';
      this.getUsers(this.currentPage);
    },
  },
};
</script>
<style lang="scss" scoped>
.input-with-select {
  width: 33%;

  .el-select .el-input {
    width: 110px;
  }
}
.el-pagination {
  text-align: right;
}

.user-info {
  color: #606266;
  font-size: 13px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/BoardList.vue